const KEY = 'imageBatchCompon';
const APPAPI = '/coapi';
var TOKEN = sessionStorage.getItem("token");
import { Injectable }              from '@angular/core';
import { Headers, Http, Response,RequestOptions }          from '@angular/http';

import { Observable } from 'rxjs/Observable';
declare var CryptoJS: any;
@Injectable()
export class localDataService {
  // @ngInject
  private APPAPI:any
  private ENDPOINT_URI:any
  private TOKEN:any;
  public socket : any;
  constructor(public http: Http) {
    this.http = http;
    this.APPAPI = APPAPI;
    var url = location.search;
    url = url.split("?token=")[1] || url.split("?Custoken=")[1];
    if (url) {
      sessionStorage.setItem("token", url);
      sessionStorage.setItem("perMi",'1')
    }
    this.TOKEN = sessionStorage.getItem("token");
  }

  static encrypt(content, key) {
    var sKey = CryptoJS.enc.Utf8.parse(key);
    var sContent = CryptoJS.enc.Utf8.parse(content);
    var encrypted = CryptoJS.AES.encrypt(sContent, sKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  }
  static decrypt(content, key) {
    var sKey = CryptoJS.enc.Utf8.parse(key);
    var decrypt = CryptoJS.AES.decrypt(content, sKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }

  tureData(res: Response) {
    let rea = localDataService.decrypt(res.text(), KEY)
    let reaobj = JSON.parse(rea);
    return reaobj || {};
  }
  
  tuoshu(orderNo):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': this.TOKEN ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    let aupara ={
      orderNo:orderNo,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI+"/W0001/details",data,options).toPromise()
                  .then(this.tureData)
                  .catch(err => {});
  }
  tuoshuUpdata(userJson,id,set):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': this.TOKEN ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    let data = {
      _id:id,
      userJson:userJson,
      attrJson:set
    }
    return this.http.post(APPAPI+"/shippingOrder/updateById",data,options).toPromise()
                  .then(this.extractData)
                  .catch(err => {});
  }
  //测试托书的pdf地址是否可以调通
  testURLSuccess(scoreUrl):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': this.TOKEN ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    return this.http.get("http://allseeing-rar.oss-cn-shanghai.aliyuncs.com/"+encodeURI(encodeURI(scoreUrl)),options).toPromise()
                  .then(this.extractData)
                  .catch(err => console.log(false));
  }
  tuoshuList(orderOutNo,pageNum,pageSize,startTime,endTime):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': this.TOKEN ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    let aupara = {
      orderOutNo:orderOutNo,
      pageIndex:pageNum,
      pageSize:pageSize,
      startTime:startTime,
      endTime:endTime,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI+"/W0001/list",data,options).toPromise()
                  .then(this.tureData)
                  .catch(err => {});
  }
  //获取这个公司的所有业务类型
  getThisCompanyHaveSomeType(token):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': token ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    let data ={
     
    }
    return this.http.post(APPAPI+"/user/getCoBizs",data,options).toPromise()
                  .then(this.extractData)
                  .catch(err =>{});
  }
  apiCommon(url,json) {
    let headers = new Headers({ 'CusAuthorization': this.TOKEN, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(APPAPI + url, json, options).toPromise()
      .then(this.extractData)
      .catch(err =>{});
  }
  //获取海运出口列表
  haiyunList(pageIndex,pageSize):Promise<any[]>{
    let headers = new Headers({ 'CusAuthorization': this.TOKEN ,'content-type':'application/json'});
    let options = new RequestOptions({ headers: headers});
    let data ={
      dataVersion: "81",
      declarationStatus: "",
      orderStatus: "",
      pageIndex: pageIndex,
      pageSize: pageSize,
      person: "",
      sortTime: "createTime"
    }
    // return this.http.post(APPAPI+"/Y0001/list",data,options).toPromise()
       return this.http.post(APPAPI+"/W0004/list",data,options).toPromise()
                  .then(this.extractData)
                  .catch(err =>{});
  }

 
  public extractData(res: Response) {
    let body = res.json();
    //console.log(body);
    return body || { };
  }

    public handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
  identDetails(params): Promise<any[]> {
    let { orderNo, token } = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      orderNo: orderNo,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/detailsNew", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  getShippingConfig(params): Promise<any[]> {
    let { token ,...arg} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...arg,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getShippingConfig", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  getWtSailingsSc(params): Promise<any[]> {
    let { token ,...arg} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...arg,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getWtSailingsSc", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }


  
  customsDeclarationsDetail(params): Promise<any[]> {
    let { orderNo} = params
    let headers = new Headers({ 'CusAuthorization': this.TOKEN, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      orderNo: orderNo,
      // reqTime: new Date().getTime()
    }
    let data = JSON.stringify(aupara)
    return this.http.post(APPAPI + "/W0004/detail", data, options).toPromise()
      .then(this.extractData)
      .catch(err => { });
  }
  getCustomsDeclarationsPdf(params): Promise<any[]> {
    let { imgPath} = params
    let headers = new Headers({ 'CusAuthorization': this.TOKEN, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      imgPath: imgPath,
      // reqTime: new Date().getTime()
    }
    let data = JSON.stringify(aupara)
    return this.http.post(APPAPI + "/W0004/getSourceFilePDFNew", data, options).toPromise()
      .then(this.extractData)
      .catch(err => { });
  }

  saveIdentDetails(params): Promise<any[]> {
    let { orderNo, token, orderStatus, msCoID,attrJson} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      orderNo: orderNo,
      orderStatus: orderStatus, //  "0=暂存，"1"=正常推送  
      msCoID: msCoID,
      msUserID: token,
      attrJson:attrJson,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/Ms/saveAndSendData", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  saveIdentDetailsNew(params): Promise<any[]> {
    let { orderNo, token, orderStatus, msCoID,attrJson,businessType} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      orderNo: orderNo,
      orderStatus: orderStatus, //  "0=暂存，"1"=正常推送  
      msCoID: msCoID,
      msUserID: token,
      attrJson:attrJson,
      businessType,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/Ms/saveAndSendData", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }

  getPostCodeList(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getPostCodeList", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  getCodeByName(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getCodeByName", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  getCodeByNameSc(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getCodeByNameSc", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }

  updateOrAddPortCode(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/updateOrAddPortCode", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  getCodeByCode(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/getCodeByCode", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
  
  deletePortCode(params): Promise<any[]> {
    let {token,...body} = params
    let headers = new Headers({ 'CusAuthorization': token, 'content-type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let aupara = {
      ...body,
      reqTime: new Date().getTime()
    }
    let data = localDataService.encrypt(JSON.stringify(aupara), KEY)
    return this.http.post(APPAPI + "/W0001/deletePortCode", data, options).toPromise()
      .then(this.tureData)
      .catch(err => { });
  }
}

 export const localDataServices = localDataService;



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/Services/localDataServices.ts